<template>
    <div id="tool-panel">
        <tool-icons></tool-icons>
        <brush-tool-options v-show="toolState.activeTool === TOOL_BRUSH && toolState.isShowPanel" ></brush-tool-options>
        <highlighter-tool-options v-show="toolState.activeTool === TOOL_HIGHLIGHTER && toolState.isShowPanel"></highlighter-tool-options>
        <eraser-tool-options v-show="toolState.activeTool === TOOL_ERASER && toolState.isShowPanel"></eraser-tool-options>
    </div>
</template>

<script>

    import {ref, reactive, onMounted, watchEffect, computed, watch}  from "vue"
    import ToolIcons from "@/views/reader/tool/ToolIcons";
    import BrushToolOptions from "@/views/reader/tool/BrushToolOptions";
    import HighlighterToolOptions from "@/views/reader/tool/HighlighterToolOptions";
    import EraserToolOptions from "@/views/reader/tool/EraserToolOptions";
    import {useTool} from "@/modules/reader/tools/tools";

    export default {
        components:{
            ToolIcons,
            BrushToolOptions,
            HighlighterToolOptions,
            EraserToolOptions
        },
        setup(props, context) {

            const {
                toolState,
                TOOL_BRUSH,
                TOOL_HIGHLIGHTER,
                TOOL_NOTE,
                TOOL_ERASER
            } = useTool();

            return {
                toolState,
                TOOL_BRUSH,
                TOOL_HIGHLIGHTER,
                TOOL_NOTE,
                TOOL_ERASER
            }
        }
    }

</script>

<style scoped lang="scss">

    #tool-panel {
        position:absolute;
        top: -65px;
        left: 60px;
    }


</style>